import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  Avatar,
  MenuItem,
  IconButton,
} from "@mui/material";
import {
  useGetPunchDashboardQuery,
  useGetPunchDetailsQuery,
  useGetTeamQuery,
} from "../../../Api/attoDeskApi";
import { IPunchDetails, ITeam } from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import CustomCheckbox from "../../../Components/Checkbox.tsx/CustomCheckbox";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import { PaymentMethod, PaymentStatus } from "../../../Core/Enum/enum";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import PaidIcon from "@mui/icons-material/Paid";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentsIcon from "@mui/icons-material/Payments";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NumbersIcon from "@mui/icons-material/Numbers";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import ImageIcon from "@mui/icons-material/Image";
import EmpImg from "../../Attendance/Component/EmpImg";
import AvatarImg from "../../../Images/avatar.png";
import { toProperCase } from "../../../Components/Validation/toProperCase";

const formattedDate = (dateString: string) => {
  const date = new Date(dateString + "-01");
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
  };
  return date.toLocaleDateString("en-CA", options);
};

const getPaymentStatusText = (status: Number) => {
  switch (status) {
    case 1:
      return "Active";
    case 2:
      return "In Active";
    default:
      return "Unknown";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectedCoursing, setSelectedCoursing] =
    useState<IPunchDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedImg, setSelectedImg] = useState<IPunchDetails | null>(null);
  const [openDialogImg, setOpenDialogImg] = useState(false);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IPunchDetails | null>(null);
  const [selectedIsBooked, setSelectedProductIsBooked] = useState<string>("");

  const previousMonth = dayjs().subtract(1, "month").format("YYYY-MM");
  const previousNextMonth = dayjs().subtract(2, "month").format("YYYY-MM");
  const [paymentMonthYear, setPaymentMonthYear] = useState(previousMonth);

  const { data, isLoading, isError, refetch } = useGetPunchDetailsQuery({
    searchText: "",
  });

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(selectedValue);
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: dashboardData, isLoading: dashboardIsLoading } =
    useGetPunchDashboardQuery();

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const teamMap = useMemo(() => {
    const map = new Map<number, { name: string; image: string }>(); // Map to hold id as key and an object with name and image as value
    teamList?.forEach((teamMember) => {
      const fullName = `${toProperCase(teamMember.teamFirstName)} ${toProperCase(teamMember.teamLastName)}`;
      map.set(teamMember.id, { name: fullName, image: teamMember.teamImg });
    });
    return map;
  }, [teamList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (coursing: IPunchDetails) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleOpenDialogImg = (coursing: IPunchDetails) => {
    setSelectedImg(coursing);
    setOpenDialogImg(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };
  const handleCloseDialogImg = () => {
    setSelectedImg(null);
    setOpenDialogImg(false);
  };

  const handleIsBookedPaymentMethod = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductIsBooked(selectedValues);
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IPunchDetails[] = Array.isArray(data?.data)
    ? (data?.data as IPunchDetails[])
    : [];

  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  pt={2}
                  alignContent={"Left"}
                  textAlign={"left"}
                >
                  <Typography className={classes.h3Heading}>
                    Punch In
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.total_punch_in}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box className={classes.editButtonProfileBox}>
                    <NumbersIcon sx={{ fontSize: 32 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  pt={2}
                  alignContent={"Left"}
                  textAlign={"left"}
                >
                  <Typography className={classes.h3Heading}>
                    Punch Out
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.total_punch_out}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box className={classes.editButtonProfileBox}>
                    <NumbersIcon sx={{ fontSize: 32 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  pt={2}
                  alignContent={"Left"}
                  textAlign={"left"}
                >
                  <Typography className={classes.h3Heading}>
                    Employee
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.active_employees}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box className={classes.editButtonProfileBox}>
                    <NumbersIcon sx={{ fontSize: 32 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  pt={2}
                  alignContent={"Left"}
                  textAlign={"left"}
                >
                  <Typography className={classes.h3Heading}>Active</Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.status_counts?.[1] ?? 0}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box className={classes.editButtonProfileBox}>
                    <NumbersIcon sx={{ fontSize: 32 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          {/* <Grid item lg={2.4} md={2} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  pt={2}
                  alignContent={"Left"}
                  textAlign={"left"}
                >
                  <Typography className={classes.h3Heading}>
                    Total Amount
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    ${dashboardData?.data.totalAmount}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  pt={2}
                  alignContent={"center"}
                >
                  <Box className={classes.editButtonProfileBox}>
                    <PaidIcon sx={{ fontSize: 32 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid> */}
        </Grid>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={4}
              md={4}
              sm={4}
              xs={4}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                All Punch In Out Details
              </Typography>
            </Grid>
            {/* <Grid
              item
              lg={8}
              md={8}
              sm={8}
              xs={8}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <TextField
                    select
                    size="small"
                    placeholder="Peyment Method"
                    sx={{ flexGrow: 1, width: "100%", minWidth: "100px" }}
                    value={selectedIsBooked || ""}
                    onChange={handleIsBookedPaymentMethod}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                  >
                    <MenuItem value="">All</MenuItem>

                    {Object.entries(PaymentMethod).map(
                      ([key, value], index) => (
                        <MenuItem key={index} value={value}>
                          {value}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Grid>
                <Grid item>
                  <TextField
                    select
                    size="small"
                    sx={{ flexGrow: 1, width: "100%" }}
                    value={paymentMonthYear}
                    onChange={handleIsBooked}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                  >
                    <MenuItem value={previousMonth}>Current Month</MenuItem>
                    <MenuItem value={previousNextMonth}>Last Month</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <CustomCheckbox name="checkbox" />
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>#</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Employee Name</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Image</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Date & Time</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Punch Action</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isError || coursings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    coursings
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: IPunchDetails, index) => (
                        <TableRow
                          key={row.id}
                          className={classes.tableRowHover}
                          // sx={{
                          //   backgroundColor: row.isPreviousPaymentPaid
                          //     ? "#f79aa61c"
                          //     : "transparent",
                          // }}
                        >
                          <TableCell className={classes.tablCell}>
                            <CustomCheckbox name="checkbox" />
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              <Grid item>
                                <Box className={classes.SelectImageTableBox}>
                                  {teamMap.get(row.empid)?.image ? (
                                    <img
                                      src={teamMap.get(row.empid)?.image}
                                      alt="Category Image"
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <Avatar
                                    alt="Travis Howard"
                                    src={AvatarImg}
                                      className={classes.SelectImageTable}
                                    ></Avatar>
                                  )}
                                </Box>
                              </Grid>
                              <Grid
                                item
                                textAlign={"center"}
                                alignContent={"center"}
                              >
                                <Typography className={classes.nameTableList}>
                                  {teamMap.get(row.empid)?.name || ""}
                                </Typography>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                           
                              <Grid container spacing={1}>
                                <Grid item>
                                  <Box className={classes.SelectImageTableBox}>
                                    <IconButton
                                      onClick={() => handleOpenDialog(row)} // Trigger the modal with employee ID
                                      // className={classes.SelectImageTable}
                                    >
                                      <ImageIcon
                                        className={classes.SelectImageTable}
                                      />
                                    </IconButton>
                                  </Box>
                                </Grid>
                              </Grid>
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            {row.punched_time}
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Box
                              className={
                                row.punch_action === "punch_in"
                                  ? classes.editButtonStatusPunchIn
                                  : classes.editButtonStatusPaid
                              }
                            >
                              {row.punch_action}
                            </Box>
                          </TableCell>
                          {/* <TableCell className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.editButtonList}
                                  onClick={() => handleOpenDialog(row)}
                                >
                                  <PaymentsIcon
                                    className={classes.editListIcon}
                                  />
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.viewButtonList}
                                  onClick={() => handleOpenDialogImg(row)}
                                >
                                  <ChangeCircleIcon
                                    className={classes.viewListIcon}
                                  />
                                </Button>
                              </Grid>
                            </Grid>
                          </TableCell> */}
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
              <Grid
                spacing={5}
                p={"18px"}
                py={4}
                justifyContent={"end"}
                container
                textAlign={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <Grid
                  sx={{
                    textAlign: "end",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Pagination
                    count={coursings.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                  />
                </Grid>
              </Grid>
            </TableContainer>
          </Grid>
        </Card>
      </Grid>
      {selectedCoursing && (
        <EmpImg
          openModel={openDialog}
          handleCloseDialog={handleCloseDialog}
          imgId={String(selectedCoursing.id)}
        />
      )}
    </Grid>
  );
};

export default Index;
